// Assuming the string is in form (\d+)p. IE: 1080p, 720p, etc...
export const getResolution = (resolution?: string | null, defaultResolution = 1080): number => {
  if (!resolution) return defaultResolution;
  const match = resolution.match(/(\d+)p/);
  if (!match) return defaultResolution;

  const parsedResolution = Number(match[1]);
  return Number.isNaN(parsedResolution) ? defaultResolution : parsedResolution;
};
